<template>
    <div>
        <header>
            <div class="container">
                <a href="https://brytonprinting.com/"><img src="img/header.jpg" alt=""></a>

            </div>
        </header>
        <div class="container">
            <div class="row">
                 
                <div class="col-lg-12" style="min-height:500px;">
                    <div>
                        <Form class="form-area" id="quoteForm1">
                            <h2>Thanks for reaching out!</h2>
                            <div class="mb-3">
                                <label>
                                    We've received your request and our team is reviewing your project details now.<br />
                                    You'll hear back from us soon with a personalized estimate tailored to your needs and budget.

                                    <br />
                                    In the meantime, feel free to Call us at <a href="tel:714-993-4800" style="color: #6c549d; font-weight: 700;">714-993-4800</a>
                                    or email <a href="mailto:Jeff@BrytonPrinting.com" style="color: #6c549d; font-weight: 700;">Jeff@BrytonPrinting.com</a> if you have any questions.
                                </label>
                                <br />

                            </div>
                        </Form>
                        <button type="submit" class="btn btn-primary submit-btt" style="width: 330px;font-size:medium !important;" @click="goToPage">Go Back To Free Estimation Page</button>
                    </div>
                </div>
                <footer class="contact-footer">
                    <div class="footer-top">
                        <div class="footer-logo-section">
                            <p>&copy;2012-2025 Bryton Printing, All Rights Reserved.</p>
                        </div>
                        <div class="footer-details">
                            <div class="personal-info">
                                <h3>Contact</h3>
                                <p>Jeff Weston</p>
                                <p>
                                    <a href="tel:714-993-4000">
                                        714-993-4000
                                    </a>
                                </p>
                                <p>
                                    <a href="mailto:Jeff@BrytonPrinting.com">
                                        Jeff@BrytonPrinting.com
                                    </a>
                                </p>
                            </div>
                            <div class="company-info">
                                <h3>Address</h3>
                                <p>Bryton Printing</p>
                                <p>3345 E. Miraloma Ave. Unit 134</p>
                                <p>Anaheim, CA 92806</p>
                                <p><a href="#">Map / Directions</a></p>
                            </div>
                        </div>
                    </div>

                </footer>
                <footer class="mobile">
                    <div class="footer-logo">
                        <img src="img/footer-logo.jpg" alt="">
                    </div>
                    <div class="footer-links">
                        <div class="personal-info">
                            <h3>Contact</h3>
                            <p>Jeff Weston</p>
                            <p>
                                <a href="tel:714-993-4000">
                                    714-993-4000
                                </a>
                            </p>
                            <p>
                                <a href="mailto:Jeff@BrytonPrinting.com">
                                    Jeff@BrytonPrinting.com
                                </a>
                            </p>
                        </div>
                        <div class="company-info">
                            <h3>Address</h3>
                            <p>Bryton Printing</p>
                            <p>3345 E. Miraloma Ave. Unit 134</p>
                            <p>Anaheim, CA 92806</p>
                            <p><a href="#">Map / Directions</a></p>
                        </div>
                        <div class="copyright">
                            &copy;2012-2025 Bryton Printing, All Rights Reserved.
                        </div>
                    </div>

                </footer>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        methods: {
            goToPage() {
                this.$router.push('/Booklet-Catalog-Book-Printing');
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        }
    }
</script>
<style scoped>
</style>